import './NavigationEntry.css'

function NavigationEntry(props) {
    const navigationEntryClasses = `navigation-entry ${props.swiperIndex === props.index ? 'active' : ''}`;

    return (
        <div className={navigationEntryClasses}>
            <div>
                {props.folder[0].title}
            </div>
            <div>
                {props.folder[0].client}
            </div>
            <div>
                {props.folder[0].type}
            </div>
        </div>
    )
}


export default NavigationEntry;